import { render, staticRenderFns } from "./information-pic-and-file.vue?vue&type=template&id=052d3790&scoped=true"
import script from "./information-pic-and-file.vue?vue&type=script&lang=js"
export * from "./information-pic-and-file.vue?vue&type=script&lang=js"
import style0 from "./information-pic-and-file.vue?vue&type=style&index=0&id=052d3790&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052d3790",
  null
  
)

export default component.exports